<template>
	<q-tabs class="fit" v-model="tab" @select="changeTab" swipeable v-if="rankings">
		<q-tab slot="title" name="t-all" :label="$t('all')" />

		<q-tab
			slot="title"
			:name="`t-${index}`"
			:label="rank.area"
			v-for="(rank, index) in user_firebase_document_ranking_areas"
			:key="`t-${index}`"
		/>

		<q-tab-pane name="t-all">
			<q-list no-border separator striped>
				<q-item
					v-for="(ranking, index) in filteredRanking"
					:key="index"
					v-if="filteredRanking.length > 0"
				>
					<q-item-side :color="ranking.i == id ? 'black' : ''">
						<span v-if="ranking.i == id">
							<b># {{ index + 1 }}</b>
						</span>
						<span v-else> # {{ index + 1 }} </span>
					</q-item-side>

					<q-item-side style="width: 60px;">
						<img :src="getImage(ranking.i)" class="round-avatar" @error="imageUrlAlt" />
					</q-item-side>

					<q-item-side class="desktop-only" :color="ranking.i == id ? 'black' : ''">
						<span v-if="ranking.i == id">
							<b>{{ ranking.n }}</b>
						</span>
						<span v-else>
							{{ ranking.n }}
						</span>
					</q-item-side>

					<q-item-main class="text-right" v-if="ranking.s">
						<q-item-tile>{{ getScore(ranking.s) }}</q-item-tile>
					</q-item-main>

					<q-item-main class="text-right" v-else>
						<q-item-tile>{{ getScore(0) }}</q-item-tile>
					</q-item-main>
				</q-item>
			</q-list>

			<q-inner-loading :visible="filteredRanking.length == 0">
				<q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
			</q-inner-loading>
		</q-tab-pane>

		<q-tab-pane
			:name="`t-${index}`"
			v-for="(rank, index) in user_firebase_document_ranking_areas"
			:key="`p-${index}`"
		>
			<q-list no-border separator striped>
				<q-item
					v-for="(ranking, index) in rankings"
					:key="index"
					v-if="rankings.length > 0"
				>
					<q-item-side> # {{ index + 1 }} </q-item-side>

					<q-item-side style="width: 60px;">
						<img
							:src="getImage(ranking.user_id)"
							class="round-avatar"
							@error="imageUrlAlt"
						/>
					</q-item-side>

					<q-item-side class="desktop-only">
						{{ ranking.full_name }}
					</q-item-side>

					<q-item-main class="text-right" v-if="ranking.score">
						<q-item-tile>{{ getScore(ranking.score) }}</q-item-tile>
					</q-item-main>

					<q-item-main class="text-right" v-else>
						<q-item-tile>{{ getScore(0) }}</q-item-tile>
					</q-item-main>
				</q-item>

				<q-item>
					<q-inner-loading :visible="rankings.length == 0">
						<q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
					</q-inner-loading>
				</q-item>
			</q-list>

			<div class="row justify-center" v-if="rankings.length > 0 && has_next_page">
				<div class="col-xs-12 col-sm-4">
					<q-btn
						:label="$t('load_more')"
						color="tertiary"
						class="full-width"
						@click="loadRanking()"
					/>
				</div>
			</div>
		</q-tab-pane>
	</q-tabs>
</template>

<script>
import { db } from 'plugins/vuefire'
import { mapGetters } from 'vuex'

export default {
	props: ['user_firebase_document_ranking_areas', 'user_firebase_document'],

	data() {
		return {
			tab: 't-all',
			rankings: [],
			document: '',
			page: 1,
			page_size: 50,
			has_next_page: true,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			id: 'common/id',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		filteredRanking: function() {
			if (this.rankings && this.rankings.users) {
				this.ordered_ranking = this.rankings.users.sort((a, b) =>
					parseFloat(a.s) < parseFloat(b.s)
						? 1
						: parseFloat(b.s) < parseFloat(a.s)
						? -1
						: 0
				)

				let obj = this.ordered_ranking.find((obj) => {
					return obj.i === this.id
				})
				if (obj) {
					this.user_position = obj
					let pos = this.rankings.users
						.map((e) => {
							return e.i
						})
						.indexOf(this.user_position.i)
					if (pos > 4) {
						this.user_position.pos = pos
					} else {
						this.user_position = null
					}
				} else {
					this.user_position = null
				}

				return this.ordered_ranking
			} else return []
		},
	},

	methods: {
		getImage(id) {
			return `${process.env.SITE_URL}/media_public/users/${id}/images/50x50.jpg`
		},

		imageUrlAlt(event) {
			let alt = 'statics/user-alt.svg'
			event.target.src = alt
			event.target.classList = 'round-avatar outline-avatar'
		},

		getImageDB(ranking) {
			return process.env.BUCKET_URL + ranking.image
		},

		changeTab() {
			this.rankings = []

			if (this.tab != 't-all') {
				let position = parseInt(this.tab.substr(2))
				this.document = this.user_firebase_document_ranking_areas[position].document

				this.has_next_page = true
				this.rankings = []
				this.page = 1
				this.loadRanking()
			} else {
				this.$bind(
					'rankings',
					db.collection('ranking').doc(`${this.user_firebase_document}`)
				).then((rankings) => {
					this.rankings === rankings
				})
			}
		},

		loadRanking() {
			if (this.has_next_page) {
				let data = {
					page_size: this.page_size,
					page: this.page,
				}

				this.$axios
					.get(
						`/etraining_ranking/ranking/${this.document}/?` + this.$qs.stringify(data),
						this.getHeader
					)
					.then((response) => {
						response.data.results.map((r) => {
							this.rankings.push(r)
						})

						if (!response.data.next) this.has_next_page = false
						else this.page++
					})
					.catch((e) => {
						console.log(e)
					})
			}
		},

		getScore(score) {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})

			if (score && client && client.ranking_use_decimal) {
				return score.toFixed(2)
			} else if (score) {
				return score.toFixed(0)
			} else return
		},
	},

	created() {
		this.$bind('rankings', db.collection('ranking').doc(`${this.user_firebase_document}`)).then(
			(rankings) => {
				this.rankings === rankings
			}
		)
	},
}
</script>

<style lang="stylus" scoped>
.round-avatar
    width 2.5rem
    height 2.5rem
    border-radius 50%

.outline-avatar
    border 2px solid black
</style>
